import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e48aba7")

_pushScopeId("data-v-4e48aba7")
const _hoisted_1 = { class: "about-list" }
const _hoisted_2 = { class: "about-list__item" }
const _hoisted_3 = { class: "swiper-control" }
const _hoisted_4 = {
  ref: "prev",
  class: "btn swiper-button-next"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("svg", {
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M3.7124 8.30001L6.42907 5.58335C6.7499 5.26251 6.7499 4.73751 6.42907 4.41668L3.7124 1.70001",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_6 = {
  ref: "next",
  class: "btn swiper-button-prev"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M3.7124 8.30001L6.42907 5.58335C6.7499 5.26251 6.7499 4.73751 6.42907 4.41668L3.7124 1.70001",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_swiper, {
      "slides-per-view": 1.5,
      "space-between": 30,
      navigation: {
      prevEl: $setup.prev,
      nextEl: $setup.next,
    }
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.list, (item, itemInd) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, { key: itemInd }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_svg_icon, {
                  name: item.icon,
                  class: "about-list__item"
                }, null, 8, ["name"]),
                _createVNode("span", null, _toDisplayString(_ctx.$t(item.text)), 1)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128 /* KEYED_FRAGMENT */)),
        _createVNode("div", _hoisted_3, [
          _createVNode("button", _hoisted_4, [
            _hoisted_5
          ], 512),
          _createVNode("button", _hoisted_6, [
            _hoisted_7
          ], 512)
        ])
      ]),
      _: 1
    }, 8, ["navigation"])
  ]))
})